<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn flat color="primary" @click="goBack">
          <v-icon left>arrow_back</v-icon>
          ย้อนกลับไปหน้าค้นหา
        </v-btn>
      </v-flex>
    </v-layout>

    <v-card class="pa-3 mt-2">
      <v-layout row wrap>
        <v-flex xs12>
          <span class="headline font-weight-bold">ข้อมูลผู้ใช้</span>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="mt-2">
        <v-flex xs12 sm6>
          <div>หมายเลขประจำตัวประชาชน: {{ user.card_id || "-" }}</div>
          <div>
            ชื่อ-นามสกุล:
            {{ (user.title || "") + (user.name || "") + " " + (user.surname || "") }}
          </div>
          <div>หน่วยงาน: {{ user.companyname || "-" }}</div>
        </v-flex>
        <v-flex xs12 sm6>
          <div>เบอร์โทรศัพท์: {{ user.phone || "-" }}</div>
          <div>อีเมล: {{ user.email || "-" }}</div>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card class="pa-3 mt-3">
      <ComponentAdminUserNoteSeeding :card-id="cardId" />
    </v-card>
  </v-container>
</template>

<script>
import ComponentAdminUserNoteSeeding from "@/components/admin/ComponentAdminUserNoteSeeding.vue";
import { handleAjaxError } from "@/utils/common";

export default {
  components: {
    ComponentAdminUserNoteSeeding
  },
  data() {
    return {
      user: {
        card_id: "",
        title: "",
        name: "",
        surname: "",
        phone: "",
        email: "",
        companyname: "",
        total_plant_amount: 0
      }
    };
  },
  computed: {
    cardId() {
      return this.$route.params.card_id;
    }
  },
  created() {
    this.fetchUserSummary();
  },
  methods: {
    fetchUserSummary() {
      const payload = {
        card_id: this.cardId,
        page: 1,
        page_size: 1
      };
      this.axios
        .post(
          process.env.VUE_APP_IPFLASK + "/queryUser",
          payload,
          { withCredentials: true }
        )
        .then(response => {
          const data = response.data || {};
          const items = data.items || [];
          if (items.length > 0) {
            this.user = items[0];
          }
        })
        .catch(error => {
          handleAjaxError(error, this);
        });
    },
    goBack() {
      this.$router.back();
    }
  },
  filters: {
    comma(val) {
      if (val === null || val === undefined) return "";
      return Number(val).toLocaleString();
    }
  }
};
</script>

<style scoped>
</style>
